import { Input } from "../ui/input";
import { Users } from "lucide-react";

const STAT_FIELDS = [
  { key: "goals", testid: true, max: undefined },
  { key: "assists", testid: true, max: undefined },
  { key: "yellow", testid: false, max: undefined },
  { key: "red", testid: false, max: undefined },
  { key: "minutes", testid: false, max: 120 },
];

function MatchStatRow({ player, stat, onUpdate }) {
  return (
    <div
      className="grid grid-cols-[auto_1fr_repeat(5,minmax(0,1fr))] gap-2 items-center px-3 py-2 border-t border-slate-100"
      data-testid={`match-stat-row-${player.id}`}
    >
      <span className="h-6 min-w-6 px-1 rounded bg-slate-100 text-xs font-bold flex items-center justify-center">
        {player.jersey_number ?? "—"}
      </span>
      <span className="text-sm truncate">
        {player.last_name} {player.first_name}
      </span>
      {STAT_FIELDS.map((field) => (
        <Input
          key={field.key}
          type="number"
          min="0"
          max={field.max}
          value={stat[field.key]}
          onChange={(e) => onUpdate(player.id, field.key, e.target.value)}
          className="h-8 text-center text-sm"
          data-testid={field.testid ? `stat-${field.key}-${player.id}` : undefined}
        />
      ))}
    </div>
  );
}

export default function MatchStatsTable({ players, stats, onUpdate, emptyStat }) {
  return (
    <div>
      <div className="label-eyebrow mb-2 flex items-center gap-2">
        <Users size={12} /> Statistiche per giocatore
      </div>
      <div className="border border-slate-200 rounded-xl overflow-hidden">
        <div className="grid grid-cols-[auto_1fr_repeat(5,minmax(0,1fr))] gap-2 bg-slate-50 px-3 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider">
          <div>#</div>
          <div>Giocatore</div>
          <div className="text-center">Goal</div>
          <div className="text-center">Assist</div>
          <div className="text-center">Gialli</div>
          <div className="text-center">Rossi</div>
          <div className="text-center">Min.</div>
        </div>
        {players.map((p) => (
          <MatchStatRow
            key={p.id}
            player={p}
            stat={stats[p.id] || emptyStat(p.id)}
            onUpdate={onUpdate}
          />
        ))}
        {players.length === 0 && (
          <div className="p-8 text-center text-slate-400 text-sm">
            Nessun giocatore convocato.
          </div>
        )}
      </div>
    </div>
  );
}
